import { useContext, useEffect } from 'react'
import { ModalContext } from '@nv/contexts'
import ThumbsUpIcon from '@nv/images/design/thumbs-up-icon'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import styles from './SuccessQrUpdated.module.scss'

export const SuccessQrUpdated = ({ admin }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { setHeaderLabel, setBtns } = useContext(ModalContext)

  useEffect(() => {
    setHeaderLabel(t('auth.qrCode.successModal.header'))
    setBtns([{ text: t('buttons.ok'), onClick: () => (admin ? navigate('/admin/my-account') : navigate('/voting/voter/my-account')) }])
  }, [])

  return (
    <div className={styles['container']}>
      <ThumbsUpIcon color={'var(--success-color)'} />
      <span className={styles['title']}>{t('auth.qrCode.successModal.text')}</span>
    </div>
  )
}
